const NBSP = '\u00A0'

export default (text) => {
  const words = text
    .split(' ')
    .reverse()

  if (words.length <= 3) {
    return text
  }
  const [lastWord, secondLastWord, ...rest] = words

  return `${rest.reverse().join(' ')} ${secondLastWord}${NBSP}${lastWord}`
}
